import React, { useState } from "react";
import { ColorPickerControl } from "@design-system/ColorPickerControl/ColorPickerControl";
import { VStack } from "@design-system/VStack/VStack";
import { TextControl } from "./playgroundControls";
import { SandboxLayout } from "./SandboxLayout";
import { ShowcasePreview } from "./ShowcasePreview";
import gridStyles from "./playgroundControls.module.scss";
import styles from "./SpecializedInputPlayground.module.scss";

const presetColors = [
    { label: "Ink", value: "#0F172A" },
    { label: "Blue", value: "#2563EB" },
    { label: "Green", value: "#15803D" },
    { label: "Amber", value: "#B45309" },
];

export const ColorPickerControlPlayground = () => {
    const [color, setColor] = useState("#2563EB");
    const [ariaLabel, setAriaLabel] = useState("Accent color");

    return (
        <SandboxLayout
            controls={
                <>
                    <section>
                        <h2>Accessible label</h2>
                        <VStack gap={12}>
                            <TextControl
                                label="ariaLabel"
                                value={ariaLabel}
                                onChange={setAriaLabel}
                            />
                            <p className={styles.hint}>
                                The swatch, the native palette input and the hex
                                field each get their own accessible name derived
                                from this value.
                            </p>
                        </VStack>
                    </section>
                    <section className={styles.fields}>
                        <h2>Value</h2>
                        <p className={styles.hint}>
                            Presets are showcase state that write to the
                            component&apos;s <code>value</code> prop — the same
                            pattern the invoice design panel uses.
                        </p>
                        <div className={styles.presetRow}>
                            {presetColors.map((preset) => (
                                <button
                                    key={preset.value}
                                    type="button"
                                    className={styles.presetSwatch}
                                    style={{ background: preset.value }}
                                    aria-label={preset.label}
                                    title={preset.label}
                                    onClick={() => setColor(preset.value)}
                                />
                            ))}
                        </div>
                        <p className={styles.hint}>
                            Typing an invalid hex keeps the text in the field
                            without calling <code>onChange</code>; blurring
                            restores the last valid value.
                        </p>
                    </section>
                </>
            }
        >
            <ShowcasePreview
                summary={color}
                output={JSON.stringify(
                    {
                        componentProps: {
                            value: color,
                            ariaLabel,
                        },
                        showcaseState: {
                            presetColors: presetColors.map(
                                (preset) => preset.value,
                            ),
                        },
                    },
                    null,
                    2,
                )}
            >
                <VStack className={gridStyles.fillWidth} gap={16}>
                    <ColorPickerControl
                        value={color}
                        onChange={setColor}
                        ariaLabel={ariaLabel}
                    />
                    <div
                        className={styles.colorSample}
                        style={{ background: color }}
                    />
                    <p className={styles.hint}>
                        The tinted block above is showcase-only local CSS. The
                        component itself renders just the swatch and the hex
                        field.
                    </p>
                </VStack>
            </ShowcasePreview>
        </SandboxLayout>
    );
};
